<template>
  <div>
    <el-input disabled size="mini" placeholder="请选择链接" :value="value">
      <template slot="append">
        <div @click="dialogVisible=true" class="y-pointer">选择链接</div>
      </template>
    </el-input>
    <el-dialog custom-class="custom" append-to-body title="选择链接" :show-close="false" :visible.sync="dialogVisible" width="50rem">
      <el-tabs v-model="activeName" style="height: 20rem">
        <el-tab-pane label="系统链接" name="sys">
          <template v-for="(item,key) in sys">
            <el-button style="margin: .5rem" @click="chooseSys(key)" :key="key">{{item.title}}</el-button>
          </template>
        </el-tab-pane>
        <el-tab-pane label="自定义商品专题页" name="theme">
          <template v-for="(item,key) in theme">
            <el-button @click="chooseTheme(key)" :key="key">{{item.title}}</el-button>
          </template>
        </el-tab-pane>
        <el-tab-pane v-if="useCustom" label="自定义链接" name="custom">
          <div class="flex-def flex-zCenter flex-cCenter" style="height: 10rem">
            <el-input style="width: 30rem" placeholder="请输入" v-model="custom">
              <template slot="append">
                <el-button @click="sureCustom" style="padding:0 3rem;" size="mini">确认</el-button>
              </template>
            </el-input>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "y_choose_link",
  model:{
    prop:"modelval",
    event:'change'
  },
  props:{
    useCustom:{
      type:Boolean,
      default: true
    },
    modelval: {
      type:String,
      default:""
    },
  },
  watch:{
    modelval(){
      this.value = this.modelval;
    },
    value(e){
      this.$emit('change',e);
    }
  },
  data(){
    return{
      value: this.modelval,
      custom:"",
      dialogVisible:false,
      activeName:"sys",
      sys:[
        {title:"首页",link:"/pages/index/index"},
        {title:"福利专题页",link:"/pages/goods/free"},
        {title:"选购加盟专题页",link:"/pages/goods/upgrade"},
        {title:"核销商品页",link:"/pages/plugin/scan-goods/list"},
        {title:"知识付费首页",link:"/pages/plugin/knowledge/index"},
        {title:"购物车页",link:"/pages/cashier/cart"},
        {title:"邀请好友页",link:"/pages/invite/index"},
        {title:"个人中心页",link:"/pages/mine/index"},
        {title:"商品列表页",link:"/pages/goods/search"},
        {title:"免单卡页",link:"/pages/plugin/privilege-card/card"},
        {title:"免单卡海报页",link:"/pages/plugin/privilege-card/mine/poster"},
        {title:"免单卡个人中心",link:"/pages/plugin/privilege-card/mine/index"},
        {title:"免单卡商家列表",link:"/pages/plugin/privilege-card/merchant-list"},
        {title:"免单卡批发商购买激活卡",link:"/pages/plugin/privilege-card/wholesaler-buy-card"},
        {title:"全部文章",link:"/pages/plugin/article/list"},
        {title:"积分兑换首页",link:"/pages/plugin/points-mall/index"},
      ],
      theme:[],
    }
  },
  mounted() {
    this.loadTheme();
  },
  methods:{
    chooseTheme(key){
      let item = this.theme[key];
      this.value = `/pages/goods/theme?tid=${item.id}`;
      this.dialogVisible = false;
    },
    loadTheme(){
      this.$u.api.shop.goods.themeSearch({page:-1}).then(res=>{
        this.theme = res.list;
      })
    },
    sureCustom(){
      this.dialogVisible=false;
      this.value = this.custom;
    },
    chooseSys(key){
      let item = this.sys[key];
      this.value = item.link;
      this.dialogVisible = false;
    },
  }
}
</script>
<style>
.custom>.el-dialog__body{
  padding: 0 20px 30px !important;
  margin: 0;
}
</style>
<style scoped>

</style>